<template>
  <div class="brand-group brand-list">
    <div
      v-for="(brand, index) in brandList"
      :key="index"
      class="brand-name"
      :class="{ 'is-flagship': brand.IsFlagshipStore }"
    >
      <BrandBtn :brand-active="brand.Followed" :brand-code="brand.Code" @update="updateData" />
      <a :href="brand.Url">{{ brand.Name }}</a>
    </div>
  </div>
</template>

<script setup>
import BrandBtn from '@components/BrandBtn.vue';

const emit = defineEmits(['update']);
const props = defineProps({
  brandList: {
    type: Array,
    required: true,
  },
});

const updateData = () => {
  emit('update');
};
</script>
